import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MessageDataService {
  public message = new BehaviorSubject<string>('');

  getMessage() {
    return this.message.asObservable();
  }

  updateMessage(newValue: string) {
    this.message.next(newValue);
  }
}
